import React, {useEffect,useState,useContext} from 'react'
import downArrow from '../images/orgarrow.svg'
import { keyContext } from './KeyContext'

function FilmOrgs({ setQ, setShowFilms, setSelectedMovieData, }) {
    const key = sessionStorage.getItem("key");
    const [orgs, setOrgs] = useState([{}]);
   const { setDistributorsName, filmBioChanged, setFilmbiochanged , clkdMovieName, setClkdMovieName} = useContext(keyContext)
    const [selectedOrg, setSelectedOrg] = useState();
    let orgExists = sessionStorage.getItem('filmOrg')


   useEffect(() => {
     const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
     if (key) {
       fetch(endpoint, {
         method: "GET",
         headers: {
           ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
         },
       })
         .then(res => {
         
          return res.json();
         } )
         .then((result) => {
           //  console.log(result)
           setOrgs(result);
          //  setOrgSelect( result[0].No)
           // console.log('biograf length',result.length)
           if(result.length === 1) {
             // console.log('gg')
             //  console.log(result[0].No)
           //  sessionStorage.setItem('default-filmID',result[0].No )
             //setDefaultFilm(film[0].No)
           }
           // setMovieNumber(result.map((number) => number.No));
         });
     }
   }, [key]);

   const handleSelect = (e) => {

    let g = e.target.value;

     setSelectedOrg(e.target.value)
     setQ('')
   // setShowFilms && setShowFilms(true)
    setFilmbiochanged(true)
    setSelectedMovieData && setSelectedMovieData([])
    setDistributorsName && setDistributorsName('')
    setClkdMovieName('')
     sessionStorage.setItem("filmOrg", e.target.value);
     window.location.reload()
  };

  return (
    <>
      <p  style={{color: '#46484c',fontWeight:700,fontSize:'18px',marginBottom:'5px'}}> Biograf</p> 
    <div className="movieListBox" style={{width:'384px'}}>
    <span className="select-line" style={{backgroundColor:  '#8d8d8d',}}></span>
    <select
className="form-select text-truncate"
onChange={handleSelect} 
value={orgExists ? orgExists : selectedOrg}  style={{height:'40px','#65696c' : '',  border:  '1px solid #8d8d8d' , backgroundImage:`url(${ downArrow})`,backgroundRepeat:'no-repeat',width:'384px'}}
>

{orgs &&
orgs.map((item,index) => {
let bb = item.City + " - " + item.Name + " " + item.No;
return (
<option key={index} value={bb} className="text-truncate"  style={{
maxWidth: 200,
marginLeft: '10px',
fontSize: "16px",
width:'295px'

}}>
{item.City} - {item.Name}
</option>
);
})}
    </select>
</div>
    </>

  )
}

export default FilmOrgs